<template>
  <section class="actor_tree_c">
    <div class="tree_label" id="treeTitle" @click="showTree">
      构件查询：<input type="text" id="key" v-model="searchKey" placeholder="输入关键字/点击回车键" autocomplete="off"
                  style="width: 140px;"></input>
    </div>
    <div class="actor_tree_box">
      <ul id="actorTree" class="ztree" style="height: 50%; position: absolute"></ul>
      <div class="loading_view">
        <div class="icon_layout">数据加载中<i class="el-icon-loading"></i></div>
      </div>
    </div>
  </section>
</template>

<script>
  import {treeModel, childrenModel} from '../../api/api'
  import "../../assets/ztree/zTreeStyle/zTreeStyle.css";

  export default {
    name: "ActorTree",
    props: {
      data: {},
      modelId: null,
      hideLabel: false,
    },
    data() {
      return {
        setting: {
          // async: {
          //   enable: true,
          //   url: this.GLOBAL.modelServerPath + "/model/modeltree",
          //   type: "post",
          //   otherParam: this.getParam,
          //   contentType: "application/json"
          // },
          view: {
            showLine: true,
            showIcon: false,
            selectedMulti: true,
            nameIsHTML: true, //允许name支持html
          },
          check: {
            enable: true
          },
          data: {
            simpleData: {
              enable: true,
              idKey: "glid",
              pIdKey: "pglid",
              rootPId: 0
            }
          },
          callback: {
            beforeClick: function (treeId, treeNode) {
              return false;
            },
            onCheck: this.actorCheck,
          }
        },
        zNodes: [
          {id: 1, pId: 0, name: "父节点1", parent: true},
          {id: 2, pId: 0, name: "子节点1", parent: true},
          {id: 3, pId: 0, name: "子节点2", parent: true}
        ],
        showBox: true,
        selectedActors: [],
        searchKey: null,
      }
    },
    methods: {
      //构建选中
      actorCheck: function (event, treeId, treeNode) {
        this.$emit('actorCheck');
        let p = this.getLastNodes(treeNode);
      },
      //递归获取选中节点的末级节点集合
      getLastNodes: function (node) {
        hasSelectionIds = [];
        ResetAllActor();
        let treeObj = $.fn.zTree.getZTreeObj("actorTree");
        let nodes = treeObj.getCheckedNodes(true);
        let nodesLength = nodes.length;
        for (let i = 0; i < nodesLength; i++) {
          let node = nodes[i];
          if (node.externalid != '0' && node.checked) {
            hasSelectionIds.push(this.modelId + "_" +node.externalid);
          }
        }
        let r = parseInt(selObjectColor.substr(1, 2), 16);
        let g = parseInt(selObjectColor.substr(3, 2), 16);
        let b = parseInt(selObjectColor.substr(5, 2), 16);
        SetActorColor(hasSelectionIds.join('#'), r, g, b);

      },
      //隐藏/显示 树
      showTree: function () {
        if (this.hideLabel) {
          if (this.showBox) {
            $("#actorTree").slideUp(function () {
              $("#treeTitle").animate({width: "55px", 'border-radius': '25px'});
              $(".model_actor_tree").animate({width: "55px", height: "25px", 'border-radius': '25px'});
            });
            this.showBox = false;
          } else {
            this.showBox = true;
            $("#treeTitle").animate({width: "100%", 'border-radius': '0px'}, function () {
              $("#actorTree").slideDown();
            });
            $(".model_actor_tree").animate({width: "240px", height: "100%", 'border-radius': '0px'});
          }
        }
      },
      getParam: function (treeId, treeNode) {
        let params = {'modelDataId': this.modelId, 'pId': treeNode.glid};
        return params;
      },
      initTree:function(){
        let params = {'modelDataId': this.modelId}
        treeModel(params, this.GLOBAL.header).then(result => {
          if (true) {
            this.treeData = result;
            $.fn.zTree.destroy();
            $.fn.zTree.init($("#actorTree"), this.setting, this.treeData);
            let treeObj = $.fn.zTree.getZTreeObj("actorTree");
            actorTreeObj = treeObj;
            treeObj.expandAll(false);
            $(".loading_view").hide();
            $('#key').attr("disabled",false);
            this.GLOBAL.fuzzySearch("actorTree", "#key", false, false)
          }
        })
      },

    },
    watch:{
      searchKey(){

          if(this.searchKey.length==0 && hasTreeSearch){
            $(".loading_view").show();
            $('#key').attr("disabled",true);
            this.initTree();
            hasTreeSearch = false;
          }
      }
    },
    mounted() {
      this.initTree();
    },
    destroyed() {
      $.fn.zTree.destroy();
    }
  }
</script>

<style scoped>
  .icon_layout {
    position: absolute;
    top: 40%;
    width: 100%;
    text-align: center;
  }

  .loading_view {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #FFf;
  }

  .actor_tree_c {
    height: 100%;
    width: 100%;
  }

  .tree_label {
    position: absolute;
    top: 0px;
    left: 0px;
    font-weight: bold;
    width: 100%;
    background: #E4E7ED;
    height: 4%;
    line-height: 30px;
    text-align: left;
    color: #76797f;
    cursor: pointer;
    text-indent: 1em;
  }

  .tree_label:hover {
    background: #c6e9ff;
  }

  .actor_tree_box {
    position: absolute;
    left: 0px;
    top: 30px;
    width: 100%;
    height: 96%;
    text-align: center;
    overflow-y: auto;
  }

  .actor_tree_box::-webkit-scrollbar { /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }

  .actor_tree_box::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .actor_tree_box::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  #key {
    border: 1px solid #c9c9c9
  }
</style>



// WEBPACK FOOTER //
// src/components/model/ActorTree.vue